import Carousel from './src/carousel'
import CarouselSlides from './src/carousel-slides'
import CarouselPager from './src/carousel-pager'
import CarouselButton from './src/carousel-button'
import CarouselThumbs from './src/carousel-thumbs'

Carousel.install = function(Vue) {
  Vue.component(Carousel.name, Carousel)
  Vue.component(CarouselSlides.name, CarouselSlides)
  Vue.component(CarouselPager.name, CarouselPager)
  Vue.component(CarouselButton.name, CarouselButton)
  Vue.component(CarouselThumbs.name, CarouselThumbs)
}

export default Carousel
